import { Directive, ElementRef, OnInit, AfterViewInit, OnDestroy } from '@angular/core';

@Directive({
    selector: '[markdownLinks]',
    standalone: true
})
export class MarkdownLinksDirective implements OnInit, AfterViewInit, OnDestroy {
    private observer: MutationObserver;

    constructor(private el: ElementRef) { }

    ngOnInit() {
        // Set up mutation observer to watch for dynamic content changes
        this.observer = new MutationObserver(() => {
            this.addTargetToLinks();
        });

        this.observer.observe(this.el.nativeElement, {
            childList: true,
            subtree: true
        });
    }

    ngAfterViewInit() {
        // Initial processing after view is initialized
        setTimeout(() => {
            this.addTargetToLinks();
        }, 0);
    }

    ngOnDestroy() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    private addTargetToLinks() {
        const links = this.el.nativeElement.querySelectorAll('a[href]');
        links.forEach((link: HTMLAnchorElement) => {
            if (!link.hasAttribute('target')) {
                link.setAttribute('target', '_blank');
                link.setAttribute('rel', 'noopener noreferrer');
            }
        });
    }
} 